<template>
  <b-row class="mb-4">
    <b-col cols="12" offset-sm="1" sm="3">
      <label>{{ label }}</label>
    </b-col>
    <b-col cols="12" sm="7">
      <color-picker
        :color="inputValue"
        @update-color="$emit('update-field', $event)"
      />
      <!-- eslint-disable-next-line vue/no-v-text-v-html-on-component -->
      <b-form-text v-if="desc" v-html="desc"></b-form-text>
    </b-col>
  </b-row>
</template>

<script>
import ColorPicker from '@/components/helper/ColorPicker.vue';

export default {
  name: 'ColorPickerRow',
  components: {
    ColorPicker,
  },
  props: {
    valueFromDb: { type: String, default: '#000000' },
    handle: { type: String, default: null },
    label: { type: String, default: null },
    desc: { type: String, default: null },
  },
  data() {
    return {
      inputValue: null,
    };
  },
  created() {
    if (this.valueFromDb) {
      this.inputValue = this.valueFromDb;
    } else {
      this.inputValue = '#000000';
    }
  },
};
</script>
